import * as React from 'react';
import TextField, { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';
import { FieldProps, getIn } from 'formik';
import { useState } from 'react';
import { IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

export interface FormikTextFieldProps
    extends FieldProps,
        Omit<MuiTextFieldProps, 'name' | 'value' | 'error'> {}

export function fieldToTextField({
    disabled,
    field,
    form: { isSubmitting, touched, errors },
    ...props
}: FormikTextFieldProps): MuiTextFieldProps {
    const fieldError = getIn(errors, field.name);
    const showError = getIn(touched, field.name) && !!fieldError;

    return {
        ...props,
        ...field,
        error: showError,
        helperText: showError ? fieldError : props.helperText,
        disabled: disabled ?? isSubmitting,
        variant: props.variant,
    };
}

export default function PasswordInput({ children, ...props }: FormikTextFieldProps) {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    return (
        <TextField
            {...fieldToTextField(props)}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        >
            {children}
        </TextField>
    );
}
